import script from "./STDSDC05C02AccountManage.vue?vue&type=script&setup=true&lang=js"
export * from "./STDSDC05C02AccountManage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__